// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__X71IJ","col":"styles_col__3x9q1"};